export const List = ({ children, className }: any) => (
  <ul className={`flex list-none flex-col ${className ?? ""}`}>{children}</ul>
);
